module.exports = __webpack_public_path__ + "img/KinokoTable14.548cb764.jpg";